<div class="w-full max-w-lg rounded-2xl bg-white p-5 shadow-xl sm:p-6">
  <div class="flex items-start justify-between gap-4">
    <div class="min-w-0">
      <h2 class="text-lg font-semibold text-slate-950">Configure action</h2>
      <p class="mt-1 text-sm text-slate-500">{{ action.label }}</p>
    </div>
    <button
      type="button"
      class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-lg text-slate-500 transition hover:bg-slate-100"
      aria-label="Close"
      (click)="close()">
      ×
    </button>
  </div>

  <div class="mt-5 flex flex-col gap-3">
    @if (isType('send_email')) {
      <label class="flex flex-col gap-1.5">
        <span class="text-sm font-medium text-slate-800">To</span>
        <input
          type="email"
          class="field-input"
          placeholder="team@company.com"
          [ngModel]="draft()['to']"
          (ngModelChange)="updateConfig('to', $event)" />
      </label>
      <label class="flex flex-col gap-1.5">
        <span class="text-sm font-medium text-slate-800">Subject</span>
        <input
          type="text"
          class="field-input"
          [ngModel]="draft()['subject']"
          (ngModelChange)="updateConfig('subject', $event)" />
      </label>
      <label class="flex flex-col gap-1.5">
        <span class="text-sm font-medium text-slate-800">Body template</span>
        <textarea
          rows="4"
          class="field-input resize-y"
          [ngModel]="draft()['body']"
          (ngModelChange)="updateConfig('body', $event)"></textarea>
      </label>
    }

    @if (isType('send_slack')) {
      <label class="flex flex-col gap-1.5">
        <span class="text-sm font-medium text-slate-800">Channel</span>
        <input
          type="text"
          class="field-input"
          placeholder="#submissions"
          [ngModel]="draft()['channel']"
          (ngModelChange)="updateConfig('channel', $event)" />
      </label>
      <label class="flex flex-col gap-1.5">
        <span class="text-sm font-medium text-slate-800">Message</span>
        <textarea
          rows="3"
          class="field-input resize-y"
          [ngModel]="draft()['message']"
          (ngModelChange)="updateConfig('message', $event)"></textarea>
      </label>
    }

    @if (isType('call_webhook')) {
      <label class="flex flex-col gap-1.5">
        <span class="text-sm font-medium text-slate-800">URL</span>
        <input
          type="url"
          class="field-input"
          placeholder="https://example.com/hooks/form"
          [ngModel]="draft()['url']"
          (ngModelChange)="updateConfig('url', $event)" />
      </label>
      <label class="flex flex-col gap-1.5">
        <span class="text-sm font-medium text-slate-800">Method</span>
        <select
          class="field-input"
          [ngModel]="draft()['method']"
          (ngModelChange)="updateConfig('method', $event)">
          <option value="POST">POST</option>
          <option value="PUT">PUT</option>
          <option value="PATCH">PATCH</option>
        </select>
      </label>
    }

    @if (isType('notify_teams')) {
      <label class="flex flex-col gap-1.5">
        <span class="text-sm font-medium text-slate-800">Teams webhook URL</span>
        <input
          type="url"
          class="field-input"
          placeholder="https://outlook.office.com/webhook/…"
          [ngModel]="draft()['webhookUrl']"
          (ngModelChange)="updateConfig('webhookUrl', $event)" />
      </label>
      <label class="flex flex-col gap-1.5">
        <span class="text-sm font-medium text-slate-800">Message</span>
        <textarea
          rows="3"
          class="field-input resize-y"
          [ngModel]="draft()['message']"
          (ngModelChange)="updateConfig('message', $event)"></textarea>
      </label>
    }
  </div>

  <div class="mt-6 flex items-center justify-end gap-2 border-t border-slate-100 pt-4">
    <button
      type="button"
      class="rounded-xl px-4 py-2.5 text-sm font-medium text-slate-600 transition hover:bg-slate-100"
      (click)="close()">
      Cancel
    </button>
    <button
      type="button"
      class="rounded-xl bg-slate-900 px-4 py-2.5 text-sm font-medium text-white transition hover:bg-slate-800"
      (click)="save()">
      Save
    </button>
  </div>
</div>
